import "./DeleteSavedPalette.css";

function DeleteSavedPalette({ open, onCancel, onConfirm }) {
	if (!open) {
		return null;
	}

	return (
		<div className="delete-palette-modal__backdrop" onClick={onCancel}>
			<div
				className="delete-palette-modal"
				role="dialog"
				aria-modal="true"
				aria-labelledby="delete-palette-title"
				onClick={(event) => event.stopPropagation()}
			>
				<h3 id="delete-palette-title" className="delete-palette-modal__title">
					Delete palette?
				</h3>
				<p className="delete-palette-modal__text">
					This action cannot be undone.
				</p>
				<div className="delete-palette-modal__actions">
					<button
						className="delete-palette-modal__button"
						type="button"
						onClick={onCancel}
					>
						Cancel
					</button>
					<button
						className="delete-palette-modal__button delete-palette-modal__button--danger"
						type="button"
						onClick={onConfirm}
					>
						Delete
					</button>
				</div>
			</div>
		</div>
	);
}

export default DeleteSavedPalette;
